import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import UploadBox from '../utils/UploadBox';
import { properties } from "../../utils/Properties_es";
import InfoTooltip from '../utils/InfoTooltip';
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import { saveFilesStep, getFilesStep } from "../../services/filesWizardService";


export default function FileDataForm({ onValidate, data, updateData }) {
    const { id: idTransaction } = useParams();
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const allowedFileTypes = ".jpg,.jpeg,.png,.pdf";
    const validateForm = () => {
        const requiredFiles = [
            "interiorPhoto",
            "frontPhoto",
            "inventoryPhoto",
            "document"
        ];

        const missing = requiredFiles.filter(key => !data[key]);

        if (missing.length > 0) {
            setError(properties.files_error_missing);
            return false;
        }
        setError("");
        return true;
    };
    const handleContinue = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            onValidate(false);
            return;
        }
        // Hay una carga activa
        localStorage.setItem("filesUploading", "true");
        // Subida en segundo plano
        saveFilesStep({ idTransaction, data })
            .then(() => {
                localStorage.removeItem("filesUploading");
                setBackgroundUploading(false);
            })
            .catch((error) => {
                console.error("Error enviando archivos:", error);
                localStorage.removeItem("filesUploading");
            });
        onValidate(true);
        navigate(`/forms/${idTransaction}/costs`);
    };
    const base64ToFile = (base64, filename, mime) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new File([byteArray], filename, { type: mime });
    };
    //VALIDA SI TIENE INFO ANTERIOR
    const [loadingFiles, setLoadingFiles] = useState(true);
    const [backgroundUploading, setBackgroundUploading] = useState(false);
    useEffect(() => {
        const uploading = localStorage.getItem("filesUploading") === "true";
        setBackgroundUploading(uploading);

        async function loadInitialData() {
            try {
                setLoadingFiles(true);

                const response = await getFilesStep(idTransaction);
                if (response?.images) {
                    const [interior, front, inventory, document] = response.images;

                    updateData({
                        interiorPhoto: interior ? base64ToFile(interior, "interior.jpg", "image/jpeg") : null,
                        frontPhoto: front ? base64ToFile(front, "front.jpg", "image/jpeg") : null,
                        inventoryPhoto: inventory ? base64ToFile(inventory, "inventory.jpg", "image/jpeg") : null,
                        document: document ? base64ToFile(document, "document.pdf", "application/pdf") : null
                    });
                }
            } catch (error) {
                console.error("Error cargando archivos:", error);
            } finally {
                setLoadingFiles(false);
            }
        }

        loadInitialData();
    }, []);
    return (

        <Container
            className='px-3 px-md-4 mx-auto h-100 d-flex flex-column files-form-container'
            style={{ minHeight: "520px" }}
        >
            <Row className='pb-3 pb-md-4'>
                <h5 className='fw-bold'>{properties.files_title}</h5>
                <span style={{ fontWeight: 700, fontSize: 13 }}>
                    {properties.files_format_info}
                </span>
            </Row>

            <Row>
                {/* Fotos del comercio */}
                <Col md={6}>
                    <Card className="mb-3 mb-md-4 border rounded-5 py-2 px-2 h-100 files-form-card">
                        <Card.Body className='p-3 p-md-4'>
                            <Card.Title className='fw-bold'>
                                {properties.files_photos_title}
                            </Card.Title>

                            <Card.Text>
                                <ul>
                                    <li>Adjuntá <b>{properties.files_photos_count}</b></li>
                                    <li>Asegurate que sean <b>{properties.files_photos_quality}</b> y en <b>{properties.files_photos_resolution}</b></li>
                                    <li>Tomá las fotos desde <b>{properties.files_photos_angles}</b></li>
                                </ul>
                            </Card.Text>

                            <Row className='g-3'>
                                <Col md={4} sm={6} xs={12}>
                                    <UploadBox
                                        label={properties.files_btn_interior}
                                        onFileSelect={(file) => updateData({ interiorPhoto: file })}
                                        initialData={data.interiorPhoto}
                                        accept={allowedFileTypes}
                                        invalidTypeMessage={properties.files_error_invalid_format}
                                        invalidSizeMessage={properties.files_error_max_size}
                                        disabled={loadingFiles}
                                    />
                                </Col>

                                <Col md={4} sm={6} xs={12}>
                                    <UploadBox
                                        label={properties.files_btn_front}
                                        onFileSelect={(file) => updateData({ frontPhoto: file })}
                                        initialData={data.frontPhoto}
                                        accept={allowedFileTypes}
                                        invalidTypeMessage={properties.files_error_invalid_format}
                                        invalidSizeMessage={properties.files_error_max_size}
                                        disabled={loadingFiles}
                                    />
                                </Col>

                                <Col md={4} sm={6} xs={12}>
                                    <UploadBox
                                        label={properties.files_btn_inventory}
                                        onFileSelect={(file) => updateData({ inventoryPhoto: file })}
                                        initialData={data.inventoryPhoto}
                                        accept={allowedFileTypes}
                                        invalidTypeMessage={properties.files_error_invalid_format}
                                        invalidSizeMessage={properties.files_error_max_size}
                                        disabled={loadingFiles}
                                    />
                                </Col>
                            </Row>

                            <Row className='pt-2'>
                                <span style={{ fontWeight: 700, fontSize: 13 }}>
                                    {properties.files_drag_drop}
                                </span>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Documento */}
                <Col md={6}>
                    <Card className="mb-3 mb-md-4 border rounded-5 py-2 px-2 h-100 files-form-card">
                        <Card.Body className='p-3 p-md-4'>
                            <Card.Title className='fw-bold'>
                                {properties.files_document_title}
                                <InfoTooltip message={properties.files_tooltip} />
                            </Card.Title>

                            <Card.Text>
                                <ul>
                                    <li>
                                        {properties.files_document_detail} <b>{properties.files_document_option_health}</b> {properties.files_document_option_health_source}
                                        &nbsp; o la <b>{properties.files_document_option_patent}</b>
                                    </li>
                                </ul>
                            </Card.Text>

                            <Row className='g-3'>
                                <Col md={5} sm={6} xs={12}>
                                    <UploadBox
                                        label={properties.files_btn_document}
                                        onFileSelect={(file) => updateData({ document: file })}
                                        initialData={data.document}
                                        accept={allowedFileTypes}
                                        invalidTypeMessage={properties.files_error_invalid_format}
                                        invalidSizeMessage={properties.files_error_max_size}
                                        disabled={loadingFiles}
                                    />
                                </Col>
                            </Row>

                            <Row className='pt-2'>
                                <span style={{ fontWeight: 700, fontSize: 13 }}>
                                    {properties.files_drag_drop}
                                </span>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {error && (
                <Row>
                    <Col>
                        <span className='d-block mt-2 mb-2' style={{ color: "red", fontSize: 14 }}>
                            {error}
                        </span>
                    </Col>
                </Row>
            )}

            <Row className='mt-2 mt-md-3 mb-4 pb-2 form-actions-row'>
                <div className='d-flex justify-content-end px-0 form-actions'>
                    <div className='d-flex gap-2 form-actions-group'>
                        <Button
                            variant='outline-primary'
                            size='sm'
                            className='px-4 px-md-5 py-2 rounded-0 form-action-btn'
                            as={Link}
                            to={`/forms/${idTransaction}/commerce`}
                        >
                            {properties.btn_back}
                        </Button>

                        <Button
                            variant='primary'
                            size='sm'
                            className='px-4 px-md-5 py-2 rounded-0 form-action-btn'
                            onClick={handleContinue}
                        >
                            {properties.btn_continue}
                        </Button>
                    </div>
                </div>
            </Row>
            {loadingFiles && (
                <div className="text-center my-3 text-primary fw-bold">
                    {properties.files_loading}
                </div>
            )}

            {backgroundUploading && !loadingFiles && (
                <div className="text-center my-2 text-warning fw-bold">
                    {properties.files_uploading}
                </div>
            )}
        </Container>
    );
}